import React, {useState} from "react";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary(props) {
    let [keyword, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);    

    function handleDictionaryResponse(response) {
        setResults(response.data[0]);
    }

    function handlePexelsResponse(response) {
        setResults(response.data.photos);
    }

    function search (event) {
        
        // documentation: https://api.dictionaryapi.dev/
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiUrl).then(handleDictionaryResponse)

        let pexelsApiKey = "563492ad6f917000010000013271bcdf612a4b3091ab00f9d44e886b";
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=1`;
        // For autentication
        let headers = { Authorization: `Bearer ${pexelsApiKey}` };

        axios.get(pexelsApiUrl).then(handlePexelsResponse)
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    function load() {
        setLoaded(true);
        search();
    }

    if (loaded) {
        return (
        <div className="Dictionary">
           <section>
            <h3>Search for any word</h3> 
            <form onSubmit={handleSubmit}>
                    <input type="search" autoFocus={true} onChange={handleKeywordChange} defaultValue={props.defaultKeyword} />
            </form>
            <div className="hint">Suggested words: cats, code, music...</div>
           </section>
           <Results results={results} />
           <Photos photos={photos} />
        </div>
    );
    } else {
        load();
        return "Loading";
    }

    
}